"use strict";

var _slicedToArray = require("/codebuild/output/src073659321/src/turo-project/turo-app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});

function change(update) {
  var _update$current = update.current,
      currentValue = _update$current.value,
      entityMap = _update$current.entityMap;

  var _sort = [update.change.start, update.change.end].sort(function (a, b) {
    return a - b;
  }),
      _sort2 = _slicedToArray(_sort, 2),
      start = _sort2[0],
      end = _sort2[1];

  var selectedValue = update.current.value.slice(start + 1, end + 1);
  var valueUpdate = update.change.value;
  var newValue = update.current.value;
  newValue = currentValue.slice(0, start + 1).concat(valueUpdate).concat(currentValue.slice(end + 1));

  if (newValue[0].type !== 'block-start') {
    throw new Error('First character always needs to be block-start');
  } else if (newValue[newValue.length - 1].type !== 'block-end') {
    throw new Error('Last character always needs to be block-end');
  }

  var reverse = {
    start: start + 1,
    end: end - selectedValue.length + valueUpdate.length + 1,
    value: selectedValue
  };
  return {
    current: {
      value: newValue,
      entityMap: entityMap
    },
    change: reverse
  };
}

exports.default = change;